import React, {useRef, useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import ManagementDrop from "./ManagementDrop";
import { getProjects, clearProjects, setProjectDrop, clearProject, toggleShowHiddenProjects, getProjectsIncludingHidden } from "../../../actions/projects";
import { createContract, getContracts, clearContract, getContractsOfProject, clearContracts, getContractInvitations, clearInvitations, setContractDrop, getContractsIncludingHidden} from "../../../actions/contract";
import { getInvoices, clearInvoices, clearInvoice, setInvoiceDrop, getInvoicesIncludingHidden } from "../../../actions/invoices";
import { setActiveSidebarPage } from "../../../actions/core";
import { alertPermissionsRequired } from "../../../actions/messages";
import ContractCreateModal from "./ContractCreateModal";
// import AppendProjectModal from "./AppendProjectModal";
import Toggle from "../../common/Toggle";

import {alphabetizeByAttribute} from "../../common/Helpers";




export function ManagementDrops(props) {

const projectDrops = useSelector(state => state.projects.projectDrops);
const projectDrop = useSelector(state => state.projects.projectDrop);
const project = useSelector(state => state.projects.project);
const projects = useSelector(state => state.projects.projects);
const showHiddenProjects = useSelector(state => state.projects.showHiddenProjects);
const noProjectsExist = useSelector(state => state.projects.noProjectsExist);
const contractDrops = useSelector(state => state.contract.contractDrops);
const contractDrop = useSelector(state => state.contract.contractDrop);
const contract = useSelector(state => state.contract.contract);
const contracts = useSelector(state => state.contract.contracts);
const noContractsExist = useSelector(state => state.contract.noContractsExist);
const invitations = useSelector(state => state.contract.invitations);
const invoiceDrops = useSelector(state => state.invoices.invoiceDrops);
const invoiceDrop = useSelector(state => state.invoices.invoiceDrop);
const invoice = useSelector(state => state.invoices.invoice);
const invoices = useSelector(state => state.invoices.invoices);
const noInvoicesExist = useSelector(state => state.invoices.noInvoicesExist);
const noInvitationsExist = useSelector(state => state.contract.noInvitationsExist);
const messages = useSelector(state => state.messages);
const user = useSelector(state => state.auth.user);
const userIsCreator = user.croles.Creator;

// RENDER CLICK-OUT-OF ELEMENT
const [anyDropOpen, setAnyDropOpen] = useState(false);

const [showContractModal, setShowContractModal] = useState(false);


useEffect(() => {
    props.setActiveSidebarPage("mng");
    // CLEAR LINGERING PROJECT (if exists and component mounted from sidebar select)
    if (props.location.pathname.includes("/mng/projects/") && project.project_id) {
        // if path = project list and project exists, clear it
        props.clearProject();
    }
    // CLEANUP ON UNMOUNT
    return () => {
        (noProjectsExist || projects.length > 0) && props.clearProjects();
        (noContractsExist || contracts.length > 0) && props.clearContracts();
        (noInvitationsExist || invitations.length > 0) && props.clearInvitations();
        (noInvoicesExist || invoices.length > 0) && props.clearInvoices();
    }
}, []);

// GET ALL LISTS ON MOUNTS / UPDATE
// reducers will edit drop values on list item create/update/delete 
useEffect(() => {
    if(showHiddenProjects) {
        props.getProjectsIncludingHidden();
        props.getContractsIncludingHidden();
        props.getInvoicesIncludingHidden();
    } else {
        props.getProjects();
        props.getContractInvitations();
        props.getContracts();
        props.getInvoices();
    }
}, [showHiddenProjects]);


// DETERMINE ACTIVE TAB (for style, only on mount & url update)
const getActiveTab = () => {
    if (props.location.pathname.includes("project")) return "project";
    else if (props.location.pathname.includes("workflow")) return "workflow";
    else if (props.location.pathname.includes("invoice")) return "invoice"; 
}
const [activeTab, setActiveTab] = useState(getActiveTab());
useEffect(() => {
    !props.location.pathname.includes(activeTab) && setActiveTab(getActiveTab());
}, [props.location.pathname]);



// FILTER DROP OPTION LISTS
// project drop list is never filtered
// contracts filter if project is already selected
const contractDropsFilt = projectDrop.project_id ? 
    contractDrops.filter((contractDrop) => contractDrop.project_id === projectDrop.project_id) : 
    contractDrops;
// invoices filter if contract or project is already selected
const invoiceDropsFilt = contractDrop.contract_id ?
    invoiceDrops.filter((invoiceDrop) => invoiceDrop.contract_id === contractDrop.contract_id) :
    (projectDrop.project_id ?
        invoiceDrops.filter((invoiceDrop) => invoiceDrop.project_id === projectDrop.project_id) :
        invoiceDrops);



// SELECT A LIST ITEM: SET DROPS & REROUTE
const selectAll = (dropId) => {
    switch(dropId) {
        case "project": {
            projectDrop.project_id && props.setProjectDrop({});
            contractDrop.contract_id && props.setContractDrop({});
            invoiceDrop.invoice_id && props.setInvoiceDrop({});
            return props.history.push(`/mng/projects/list`);
        }
        case "workflow": {
            contractDrop.contract_id && props.setContractDrop({});
            invoiceDrop.invoice_id && props.setInvoiceDrop({});
            return props.history.push(`/mng/workflows/list`);
        }
        case "invoice": {
            invoiceDrop.invoice_id && props.setInvoiceDrop({});
            return props.history.push(`/mng/invoices/all`);
        }
        default: return null;
    }
}

// PUSH TO LIST FROM EXTERNAL LINK
useEffect(() => {
    switch(props.location.pathname) {
        case "/mng/projects/list": {
            project.project_id && props.clearProject()
            contract.contract_id && props.clearContract();
            invoice.invoice_id && props.clearInvoice();
        }
        case "/mng/workflows/list": {
            contract.contract_id && props.clearContract();
            invoice.invoice_id && props.clearInvoice();
        }
        case "/mng/workflows/list": {
            invoice.invoice_id && props.clearInvoice();
        }
        default: console.log("")
    }
    //
}),[props.location.pathname];


// SELECT A SINGLE ITEM: SET DROPS & REROUTE
const selectItem = (dropId, item) => {
    switch(dropId) {
        case "project": { 
            if (projectDrop.project_id !== item.project_id) {
                props.setProjectDrop(item);
                contractDrop.contract_id && props.setContractDrop({});
                invoiceDrop.invoice_id && props.setInvoiceDrop({});
            }
            return props.history.push(`/mng/project/view/${item.project_id}`)
        } 
        case "workflow": {
            if (contractDrop.contract_id !== item.contract_id) {
                props.setProjectDrop({project_name: item.project_name, project_id: item.project_id});
                props.setContractDrop(item);
                invoiceDrop.invoice_id && props.setInvoiceDrop({});
            }
            if (contracts.filter((contract) => contract.contract_id === item.contract_id)[0]?.contract_status === "Draft") {
                return item.contract_name ? props.history.push(`/mng/workflow/editparties/${item.contract_id}`) : props.history.push(`/mng/workflow/editdetails/${item.contract_id}`);
            } else return props.history.push(`/mng/workflow/view/${item.contract_id}`);
        }
        case "invoice": {
            if (invoiceDrop.invoice_id !== item.invoice_id) {
                console.log("000")
                props.setInvoiceDrop(item);
                props.setContractDrop({project_name: item.project_name, project_id: item.project_id, contract_name: item.contract_name, contract_id: item.contract_id});
                props.setProjectDrop({project_name: item.project_name, project_id: item.project_id});
            }
            if (invoices.filter(invoice => invoice.invoice_id === item.invoice_id)[0]?.invoice_status === "Draft") {
                props.history.push(`/mng/invoice/edit/${item.invoice_id}`)
            } else return props.history.push(`/mng/invoice/view/${item.invoice_id}`)
        }
    }
}

// DISPLAY INACTIVE DROPS AS EMPTY INSTEAD OF "ALL"
const projectIsEmpty = (activeTab === "workflow" || activeTab === "invoice") && !projectDrop.project_id;
const workflowIsEmpty = (activeTab === "project" || activeTab === "invoice") && !contractDrop.contract_id;
const invoiceIsEmpty = (activeTab === "project" || activeTab === "workflow") && !invoiceDrop.invoice_id;


// START TO CREATE PROJECT/WORKFLOW/INVOICE
const handleNewItem = (itemType) => {
    if (userIsCreator) {
        switch(itemType) {
            case "project": return props.history.push("/mng/project/edit/new");
            case "workflow": return setShowContractModal(true);
            case "invoice": return props.history.push("/mng/invoice/edit/new");
            default: return null;
        }
    } else {
        props.alertPermissionsRequired();
    }
}
useEffect(() => {
    if (showContractModal) {
        props.history.push(`/mng/workflow/editdetails/${contract.contract_id}`);
        setShowContractModal(false);
    }
}, [contract]);


const toListAll = (dropId) => {
    props.clearProject();
    props.clearContract();
    props.clearInvoice();
    switch(dropId) {
        case "project": return props.history.push("/mng/projects/list");
        case "workflow": return props.history.push("/mng/workflows/list");
        case "invoice": return props.history.push("/mng/invoices/all");
        default: return null;
    }
}

// render only when data exists
const allDataHasReturned =
    (noProjectsExist || projects.length > 0) && 
    (noContractsExist || contracts.length > 0) && 
    (noInvoicesExist || invoices.length > 0)

// show alert number for to-do items
const workflowAlertCount = invitations.length;
// "workflow" is the internal tab/routing key (still used for dropId, drop-grid className,
// handleNewItem, etc. -- renaming it is a larger, deliberately-deferred refactor), but it
// must never be shown to the user directly: rendering it raw here was invisible to every
// text search for "New Workflow" (that literal string exists nowhere in source or the
// built bundle) because .btn's CSS text-transform: capitalize is what turned the rendered
// "New workflow" into the "New Workflow" users actually saw on screen.
const activeTabLabel = activeTab === "workflow" ? "Contract" : activeTab;
const invoicesAlertCount = invoices.filter(invoice => (!invoice.party_responsible && invoice.invoice_status === "Draft") || (invoice.party_responsible && invoice.party_responsible.filter((party => party.user_id === user.id)).length > 0 )).length;

    return (
        <>
            {showContractModal &&
                <ContractCreateModal 
                setModalOpen={setShowContractModal} 
                answerInvite={() => console.log("answer invites")} /> }
            {anyDropOpen && 
            <div className="drop-click-out" onClick={() => setAnyDropOpen(false)}></div>}

            <div className="mng-controls-wrapper gap-below-xs gap-above-s">
                <Toggle wrapperClass="mng-proj-toggle-wrapper gap-right-m" id="toggle-show-hidden" edit={() => props.toggleShowHiddenProjects(!showHiddenProjects)} label="Include Hidden Projects"  />
                <button id={`create_${activeTab}`} className={"btn pri min-width" + (!userIsCreator ? " disabled" : "")} onClick={() => handleNewItem(activeTab)}>New {activeTabLabel}</button>
            </div>

            {allDataHasReturned &&
                <div className={`drop-grid ${activeTab}`} >
                    <ManagementDrop 
                        heading="Project"
                        dropId="project"
                        isEmpty={projectIsEmpty}
                        list={projectDrops}
                        fullList={projects} 
                        emptyListReturned={noProjectsExist}
                        selection={projectDrop} 
                        itemNameKey="project_name"
                        itemIdKey="project_id" 
                        selectItem={selectItem}
                        selectAll={selectAll} 
                        setAnyDropOpen={setAnyDropOpen}
                        anyDropOpen={anyDropOpen}
                        activeTab={activeTab}
                        new={props.location.pathname == "/mng/project/edit/new"}
                        toListAll={toListAll}
                    />
                    <ManagementDrop 
                        heading="Contract"
                        dropId="workflow"
                        isEmpty={workflowIsEmpty}
                        list={contractDropsFilt}
                        alertCount={workflowAlertCount}
                        fullList={contracts} 
                        emptyListReturned={noContractsExist}
                        selection={contractDrop} 
                        itemNameKey="contract_name"
                        itemIdKey="contract_id" 
                        selectItem={selectItem}
                        selectAll={selectAll}
                        setAnyDropOpen={setAnyDropOpen}
                        anyDropOpen={anyDropOpen}
                        activeTab={activeTab}
                        new={props.location.pathname == "/mng/workflow/editdetails/new"}
                        toListAll={toListAll}
                    />
                    <ManagementDrop 
                        heading="Invoice"
                        dropId="invoice"
                        isEmpty={invoiceIsEmpty}
                        list={invoiceDropsFilt} 
                        alertCount={invoicesAlertCount}
                        fullList={invoices}
                        emptyListReturned={noInvoicesExist}
                        selection={invoiceDrop} 
                        itemNameKey="invoice_number"
                        itemIdKey="invoice_id" 
                        selectItem={selectItem}
                        selectAll={selectAll}
                        setAnyDropOpen={setAnyDropOpen}
                        anyDropOpen={anyDropOpen}
                        activeTab={activeTab}
                        new={props.location.pathname === "/mng/invoice/edit/new"}
                        toListAll={toListAll}
                    />
                </div>
            }
        </>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {
    getProjects,
    clearProjects,
    getContracts,
    createContract,
    getContractsOfProject,
    clearContracts,
    getContractInvitations,
    clearInvitations,
    getInvoices,
    clearInvoices, 
    setActiveSidebarPage,
    setProjectDrop,
    setContractDrop,
    setInvoiceDrop,
    toggleShowHiddenProjects,
    getProjectsIncludingHidden,
    getContractsIncludingHidden,
    getInvoicesIncludingHidden,
    alertPermissionsRequired,
    clearProject,
    clearContract,
    clearInvoice,
})(ManagementDrops);


